import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

import InvestorPageHeader from "../components/investor/InvestorPageHeader";
import { fetchMyWithdrawals, getMyWithdrawalProofSignedUrl } from "../services/paymentService";

function unwrapList(data) {
  if (Array.isArray(data)) return data;
  if (data?.results && Array.isArray(data.results)) return data.results;
  return [];
}

export default function WalletWithdrawalsPage() {
  const location = useLocation();
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const flash = location.state?.message;

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      setLoading(true);
      setError("");
      try {
        const { data } = await fetchMyWithdrawals();
        if (!cancelled) setWithdrawals(unwrapList(data));
      } catch {
        if (!cancelled) {
          setWithdrawals([]);
          setError("Could not load withdrawal requests.");
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    load();
    return () => {
      cancelled = true;
    };
  }, []);

  const onViewDoc = async (withdrawalId) => {
    setError("");
    try {
      const { data } = await getMyWithdrawalProofSignedUrl(withdrawalId);
      if (!data?.url) throw new Error("No proof URL returned.");
      window.open(data.url, "_blank", "noopener,noreferrer");
    } catch (err) {
      const d = err.response?.data;
      setError(d?.detail || "Could not open withdrawal proof.");
    }
  };

  return (
    <div className="page investor-premium investor-panel wallet-page">
      <p className="wallet-breadcrumb">
        <Link to="/wallet">← Wallet & overview</Link>
      </p>
      <InvestorPageHeader
        icon="withdraw"
        title="BDT withdrawal center"
        subtitle="Withdrawal requests you have submitted (newest first)."
      />

      <div className="modal-tab-row" role="tablist" aria-label="Withdrawal views" style={{ marginBottom: 16 }}>
        <Link
          to="/wallet?withdraw=new"
          role="tab"
          className="modal-tab"
          style={{ textDecoration: "none", display: "inline-flex", alignItems: "center" }}
        >
          New request
        </Link>
        <span role="tab" aria-selected="true" className="modal-tab modal-tab--active">
          My withdrawals
        </span>
      </div>

      {flash ? (
        <p className="msg msg-success" style={{ margin: "0 0 12px" }}>
          {flash}
        </p>
      ) : null}
      {error ? (
        <p className="msg msg-error" style={{ margin: "0 0 12px" }}>
          {error}
        </p>
      ) : null}

      {loading ? (
        <p className="muted" style={{ margin: 0 }}>
          Loading…
        </p>
      ) : withdrawals.length === 0 ? (
        <p className="muted" style={{ margin: 0 }}>
          No withdrawal requests yet.
        </p>
      ) : (
        <div className="table-wrap">
          <table className="ops-table">
            <thead>
              <tr>
                <th>Submitted</th>
                <th>Amount</th>
                <th>Bank</th>
                <th>Account</th>
                <th>Status</th>
                <th>Doc</th>
                <th>Notes</th>
              </tr>
            </thead>
            <tbody>
              {withdrawals.slice(0, 60).map((w) => (
                <tr key={w.id}>
                  <td>{w.created_at ? new Date(w.created_at).toLocaleString() : "—"}</td>
                  <td>BDT {w.amount}</td>
                  <td>{w.bank_name}</td>
                  <td style={{ fontSize: 13 }}>{w.bank_account_number}</td>
                  <td>
                    <span className={`badge badge-${w.status}`}>{w.status}</span>
                  </td>
                  <td>
                    {w.payout_proof_url ? (
                      <button type="button" className="btn-secondary compact-btn" onClick={() => onViewDoc(w.id)}>
                        Doc View
                      </button>
                    ) : (
                      "—"
                    )}
                  </td>
                  <td style={{ fontSize: 13 }} className="muted">
                    {(w.status === "FAILED" || w.status === "REJECTED") && w.failure_reason ? w.failure_reason : "—"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
